import React, { useState, useCallback, useEffect, memo } from 'react'

interface FallbackImageProps
	extends React.ImgHTMLAttributes<HTMLImageElement> {
	src: string
	alt: string
}

const FallbackImage: React.FC<FallbackImageProps> = memo(
	({ src, alt, ...props }) => {
		const [currentSrc, setCurrentSrc] = useState(src)
		const [hasTriedFallback, setHasTriedFallback] = useState(false)

		useEffect(() => {
			setCurrentSrc(src)
			setHasTriedFallback(false)
		}, [src])

		const handleError = useCallback(() => {
			if (!hasTriedFallback && src) {
				const fallbackSrc = src.replace(/(\.[^.]+)$/, '_medium$1')
				setCurrentSrc(fallbackSrc)
				setHasTriedFallback(true)
			}
		}, [hasTriedFallback, src])

		return (
			<img src={currentSrc} alt={alt} onError={handleError} {...props} />
		)
	},
)

export default FallbackImage
